import React, {Component} from 'react';
import './App.css';
//import {Redirect, Route, Switch} from 'react-router-dom';
import 'typeface-abel';
import 'typeface-merriweather'
import 'typeface-nova-round';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import Main from "./components/Main";
import {BrowserRouter} from "react-router-dom";
import {Container} from "reactstrap";

class DebugRouter extends BrowserRouter {
	constructor(props) {
		super(props);
		// console.log('initial history is: ', JSON.stringify(this.history, null, 2))
		this.history.listen((location, action) => {
			// console.log(
			// 	`The current URL is ${location.pathname}${location.search}${location.hash}`
			// );
			//console.log(`The last navigation action was ${action}`, JSON.stringify(this.history, null, 2));
		});
	}
}

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			navbarHeight: 0
		}
	}

	updateNavbarHeight(height) {
		this.setState({navbarHeight: height})
	}

	updateNavbarWidth(width) {
		this.setState({navbarWidth: width})
	}


	basename = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";

	render() {
		return (
			<Container fluid style={{padding: 0, margin: 0, width: "100vw", overflowX: "hidden"}}>
				<DebugRouter basename={this.basename}>
					{/*<Header updateNavbarWidth={(width)=>this.updateNavbarWidth(width)} updateNavbarHeight={(height)=>this.updateNavbarHeight(height)} navItems={RESUME_COMPONENT_NAV_ITEMS}/>*/}
					<Main updateNavbarHeight={(height) => this.updateNavbarHeight(height)} navbarHeight={this.state.navbarHeight}
								navbarWidth={this.state.navbarWidth}/>
					{/*<Footer/>*/}
				</DebugRouter>
			</Container>
		);
	}
}

/*
				<Container fluid>
					<Row>
						<Col xs={12}>
							<Header/>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>

							<Main/>

						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<Footer/>
						</Col>
					</Row>
				</Container>

* */
export default App;
